function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

/**
 * Is Null or Undefined predicate.
 * @param value Rested value.
 */
function isNullOrUndefined(value) {
  return typeof value === 'undefined' || value === null;
}
/**
 * Is number predicate.
 * @param value Tested value.
 */

function isNumber(value) {
  return typeof value === 'number' && isFinite(value);
}
/**
 * Is string type predicate.
 * @param value
 */

function isString(value) {
  return typeof value === 'string' || value instanceof String;
}
/**
 * Is boolean type predicate.
 * @param value
 */

function isBoolean(value) {
  return value === false || value === true;
}
/**
 * Is function type predicate.
 * @param value
 * @return
 */

function isFunction(value) {
  // eslint-disable-line @typescript-eslint/ban-types
  return typeof value === 'function';
}
/**
 * Is date type predicate.
 * @param value
 */

function isDate(value) {
  return value instanceof Date;
}
/**
 * Is Object
 * @param value tested value
 */

function isObject(value) {
  if (value === null || value === undefined) {
    return false;
  }

  if (_typeof(value) !== 'object' || (value === null || value === void 0 ? void 0 : value.constructor) !== Object) {
    return false;
  }

  return true;
}

/**
 * Get today date.
 */
function today() {
  return new Date(new Date().setHours(0, 0, 0, 0));
}

// Boundary type used to determine if the date boundary should be before
// or after the specific date.
var BoundaryType;
/**
* Get the day offset from the matched Rx pattern.
*
* **Nd** = N days offset, e.g. 2d
*
* **-Nd** = -N days offset, e.g. -2d
*
* **Nw** = N weeks offset, e.g. 1w
*
* **-Nw** = -N weeks offset, e.g. -1w
*
* **Nm** = N months offset, e.g. 3m
*
* **-Nm** = -N months offset, e.g. -3m
*
* **Ny** = N years offset, e.g. 5y
*
* **-Ny** = -N years offset, e.g. -5y
*
* @param match Regular expression match array.
* @return Offset in days.
*/

(function (BoundaryType) {
  BoundaryType[BoundaryType["Start"] = 0] = "Start";
  BoundaryType[BoundaryType["End"] = 1] = "End";
})(BoundaryType || (BoundaryType = {}));

function dateOffset(match) {
  var amount = parseInt(match[1]);
  var unit = match[2];

  switch (unit) {
    case 'd':
      return amount;

    case 'w':
      return amount * 7;

    case 'm':
      return amount * 31;

    case 'y':
    default:
      return amount * 365;
  }
}
/**
 * Create a date boundary based on the boundary type.
 * @param filter Date filter.
 * @param dir Boundary direction, 0 start, 1 end.
 * @param todayDate Today's date to be used as reference
 * validating ranges.
 * @return Function accepting the relative
 * date which should be used in the comparison procedure.
 */


function dateBoundary(filter, dir, todayDate) {
  if (isNullOrUndefined(filter)) {
    return function () {
      return true;
    };
  } // Boundary offset in days


  var offset = 0; // Direct date boundary

  var isDateFilter = isDate(filter); // Convert number symbols to string

  if (!isDateFilter && isNumber(filter)) {
    filter = '' + filter;
  } // ISO date string or offsets


  if (isDateFilter === false) {
    // Parse ISO date string if provided
    if (filter.match(/^\d{4}-[0,1]\d-[0-3]\d$/)) {
      isDateFilter = true;
      filter = new Date("".concat(filter, "T00:00:00"));

      if (isNaN(filter.getTime())) {
        throw new Error("invalid \"".concat(filter, "\" ISO date string"));
      }
    } // Offset


    if (isDateFilter === false) {
      // Dynamic offset
      var dynamicOffset = filter.match(/^(-?[1-9]\d*)([dwmy])$/);

      if (dynamicOffset !== null) {
        offset = dateOffset(dynamicOffset); // or -1,0,1 (in past, today, in future)
      } else if (['-1', '1'].includes("".concat(filter))) {
        offset = Infinity * parseInt(filter); // Start 1 = tomorrow

        if (dir === BoundaryType.Start && offset > 0) {
          offset = 1; // 1 day in future, dynamic offset.
        } // End -1 = any date in past


        if (dir === BoundaryType.End && offset < 0) {
          offset = -1; // 1 day in past, dynamic offset.
        } // Illegal offset

      } else if ("".concat(filter) !== '0') {
        throw new Error("illegal \"".concat(filter, "\" date boundary"));
      }
    }
  }

  return function (date) {
    // Concrete date boundary
    if (isDateFilter) {
      if (dir === BoundaryType.Start) {
        return date.getTime() >= filter.getTime();
      }

      return date.getTime() <= filter.getTime();
    } // Offset


    if (dir === BoundaryType.Start) {
      return date.getTime() >= todayDate.getTime() + offset * 86400000;
    }

    return date.getTime() <= todayDate.getTime() + offset * 86400000;
  };
}
/**
 * Get local timezone offset as ISO string
 * E.g. '-05:00'
 * @return ISO timezone offset string
 */


function getISOTimezoneOffset() {
  function pad(value) {
    return value < 10 ? '0' + value : value;
  }

  var date = new Date();
  var sign = date.getTimezoneOffset() > 0 ? '-' : '+';
  var offset = Math.abs(date.getTimezoneOffset());
  var hours = pad(Math.floor(offset / 60));
  var minutes = pad(offset % 60);
  return sign + hours + ':' + minutes;
}
/**
 * Date validation rule.
 * The value passed into the validation function must be a Date object
 * or ISO date string: yyyy-mm-dd. Or a custom transform function can
 * be used to perform custom string to date conversion.
 * @param errorMsg Error message.
 * @param start Start date boundary.
 * If null or undefined, there is no start boundary.
 * @param end End date boundary.
 * If null or undefined, there is no end boundary.
 * @param transform Optional custom transform function, to
 * convert the testing value into date object.
 * @param todayDate Optional Today's date to be used as reference
 * validating ranges. If not provided, the start of the day in
 * the current runtime timezone will be used.
 * @return validation function, fn(value) => true|string,
 * returns true when valid, error message otherwise.
 */

function date(errorMsg, start, end, transform, todayDate) {
  var _todayDate;

  // No boundaries
  if (isNullOrUndefined(start) && isNullOrUndefined(end)) {
    console.warn("the date validation rule without start and end has\n      no validation effect, it will be always validated as true.");
    return function () {
      return true;
    };
  }

  todayDate = (_todayDate = todayDate) !== null && _todayDate !== void 0 ? _todayDate : today();
  var startBoundary = dateBoundary(start, BoundaryType.Start, todayDate);
  var endBoundary = dateBoundary(end, BoundaryType.End, todayDate);
  return function (value) {
    if (isNullOrUndefined(value)) {
      return errorMsg;
    } // String to date


    var isDateValue = isDate(value);
    var isStringValue = isString(value);

    if (isDateValue === false && isStringValue) {
      // Custom transform
      if (transform !== undefined) {
        value = transform(value); // ISO format
      } else if (value.match(/^\d{4}-[0,1]\d-[0-3]\d$/)) {
        value = new Date("".concat(value, "T00:00:00").concat(getISOTimezoneOffset())); // Invalid
      } else {
        console.warn("the date validation rule, invalid \"".concat(value, "\" date value"));
        return errorMsg;
      }
    } else if (isDateValue === false && isStringValue === false) {
      return errorMsg;
    } // Invalid date


    if (isNaN(value.getTime())) {
      throw new Error("invalid \"".concat(value, "\" ISO date string"));
    } // Check the value boundaries


    if (startBoundary(value) === false || endBoundary(value) === false) {
      return errorMsg;
    }

    return true;
  };
}

/**
 * Equal validation rule.
 * @param errorMsg Error message.
 * @param arg Matcher object, or a custom equality
 * predicate function, fn(val) returning true|false (equal / not equal).
 * @return validation function, fn(value) => true|string,
 * returns true when valid, error message otherwise.
 */
function equal(errorMsg, // eslint-disable-next-line @typescript-eslint/no-explicit-any
arg) {
  var customEqualPredicate = isFunction(arg);
  return function (value) {
    if (customEqualPredicate === false && isNullOrUndefined(value)) {
      return errorMsg;
    }

    if (customEqualPredicate) {
      if (arg(value) === false) {
        return errorMsg;
      }
    } else if (value !== arg) {
      return errorMsg;
    }

    return true;
  };
}

/**
 * Exclude validation rule.
 * @param errorMsg Error message.
 * @param exclusions List of exclusions.
 * @return validation function, fn(value) => true|string,
 * returns true when valid, error message otherwise.
 */
function exclude(errorMsg, exclusions) {
  // No exclusions
  if (exclusions.length === 0) {
    console.warn("the exclude validation rule without any exclusions\n      has no validation effect, it will be always validated as true.");
  }

  return function (value) {
    if (isNullOrUndefined(value) || !isBoolean(value) && !isString(value) && !isNumber(value)) {
      return errorMsg;
    }

    if (exclusions.indexOf(value) > -1) {
      return errorMsg;
    }

    return true;
  };
}

/**
 * Include validation rule.
 * @param errorMsg Error message.
 * @param inclusions List of inclusions.
 * @return validation function, fn(value) => true|string,
 * returns true when valid, error message otherwise.
 */
function include(errorMsg, inclusions) {
  // No inclusions
  if (inclusions.length === 0) {
    console.warn("the include validation rule without any inclusions'\n      has no validation effect, it will be always validated as false.");
  }

  return function (value) {
    if (isNullOrUndefined(value) || !isBoolean(value) && !isString(value) && !isNumber(value)) {
      return errorMsg;
    }

    if (inclusions.indexOf(value) === -1) {
      return errorMsg;
    }

    return true;
  };
}

/**
 * Length validation rule.
 * @param errorMsg Error message.
 * @param min Minimal length. If null or undefined,
 * there is no min length.
 * @param max Maximal length. If null or undefined,
 * there is no max length.
 * @return validation function, fn(value) => true|string,
 * returns true when valid, error message otherwise.
 */
function length(errorMsg, min, max) {
  var minLength = isNumber(min);
  var maxLength = isNumber(max); // No boundaries

  if (!minLength && !maxLength) {
    console.warn("the length validation rule without min and max has\n      no validation effect, it will be always validated as true.");
  }

  return function (value) {
    if (isNullOrUndefined(value)) {
      return errorMsg;
    }

    var isValueString = isString(value); // Cast to string

    if (isValueString === false && isNumber(value)) {
      value = '' + value;
    } else if (isValueString === false) {
      return errorMsg;
    } // Min


    if (minLength && value.length < min) {
      return errorMsg;
    } // Max


    if (maxLength && value.length > max) {
      return errorMsg;
    }

    return true;
  };
}

/**
 * Pattern validation rule.
 * @param errorMsg Error message.
 * @param pattern Regular expression.
 * @return validation function, fn(value) => true|string,
 * returns true when valid, error message otherwise.
 */
function pattern(errorMsg, pattern) {
  return function (value) {
    if (isNullOrUndefined(value)) {
      return errorMsg;
    }

    var isValueString = isString(value); // Cast to string

    if (isValueString === false && isNumber(value)) {
      value = '' + value;
    } else if (isValueString === false) {
      return errorMsg;
    }

    if (value.match(pattern) === null) {
      return errorMsg;
    }

    return true;
  };
}

/**
 * Present validation rule.
 * @param errorMsg Error message.
 * @return validation function, fn(value) => true|string,
 * returns true when valid, error message otherwise.
 */
function present(errorMsg) {
  return function (value) {
    if (isNullOrUndefined(value)) {
      return errorMsg;
    }

    if (isFunction(value) || isObject(value)) {
      throw new Error("present validation rule cannot validate \"".concat(value, "\""));
    }

    if (Array.isArray(value)) {
      return value.length > 0 ? true : errorMsg;
    }

    if ((value + '').trim() === '') {
      return errorMsg;
    }

    return true;
  };
}

/**
 * Range validation rule.
 * @param errorMsg Error message.
 * @param min Minimal boundary. If null or undefined,
 * there is no min boundary.
 * @param max Maximal boundary. If null or undefined,
 * there is no max boundary.
 * @return validation function, fn(value) => true|string,
 * returns true when valid, error message otherwise.
 */
function range(errorMsg, min, max) {
  var minBoundary = isNumber(min);
  var maxBoundary = isNumber(max); // No boundaries

  if (!minBoundary && !maxBoundary) {
    console.warn("the range validation rule without min and max has\n      no validation effect, it will be always validated as true.");
  }

  return function (value) {
    var isValueNumber = isNumber(value); // if the value is not a number try to cast to number

    if (isValueNumber === false && isString(value)) {
      if (value.match(/^\d+\.\d+$/)) {
        value = parseFloat(value);
      } else if (value.match(/^0$|^[1-9]\d*$/)) {
        value = parseInt(value);
      } else {
        return errorMsg;
      }
    } else if (isValueNumber === false) {
      return errorMsg;
    } // Min


    if (minBoundary && value < min) {
      return errorMsg;
    } // Max


    if (maxBoundary && value > max) {
      return errorMsg;
    }

    return true;
  };
}

/**
 * Create year boundary based on the boundary type.
 * @param filter Year filter.
 * @param dir Boundary direction, 0 start, 1 end.
 * @return Function accepting the relative year which should be used
 * in the comparison procedure.
 */

function yearBoundary(filter, dir) {
  if (isNullOrUndefined(filter)) {
    return function () {
      return true;
    };
  }

  var isStringValue = isString(filter); // Boundary offset in years

  var offset; // Dynamic offset

  var dynamicOffset;

  if (isStringValue) {
    dynamicOffset = filter.match(/^(-?[1-9]\d*)y$/);
  }

  if (dynamicOffset && dynamicOffset !== null) {
    offset = parseInt(dynamicOffset[1]); // or -1,1 (in past, in future)
  } else if (['-1', '1'].includes("".concat(filter))) {
    offset = Infinity * parseInt(filter); // Start 1 = tomorrow

    if (dir === BoundaryType.Start && offset > 0) {
      offset = 1; // 1 year in future, dynamic offset.
    } // End -1 = any date in past


    if (dir === BoundaryType.End && offset < 0) {
      offset = -1; // 1 year in past, dynamic offset.
    } // Current year

  } else if (filter === 0) {
    offset = 0;
  }

  return function (year) {
    var currentYear = today().getFullYear();

    if (offset !== undefined) {
      return dir === BoundaryType.Start ? year >= currentYear + offset : year <= currentYear + offset;
    }

    return dir === BoundaryType.Start ? year >= filter : year <= filter;
  };
}
/**
 * Year validation rule.
 * @param errorMsg Error message.
 * @param start Start year boundary.
 * If null or undefined, there is no start boundary.
 * @param end End year boundary.
 * If null or undefined, there is no end boundary.
 * @return validation function, fn(value) => true|string,
 * returns true when valid, error message otherwise.
 */


function year(errorMsg, start, end) {
  // No boundaries
  if (isNullOrUndefined(start) && isNullOrUndefined(end)) {
    console.warn('the year validation rule without start and end has ' + 'no validation effect, it will be always validated as true.');
    return function () {
      return true;
    };
  }

  var startBoundary = yearBoundary(start, BoundaryType.Start);
  var endBoundary = yearBoundary(end, BoundaryType.End);
  return function (value) {
    if (isNullOrUndefined(value)) {
      return errorMsg;
    } // Get the year


    if (isDate(value)) {
      value = value.getFullYear();
    } else {
      value = parseInt(value, 10);
    }

    if (value < 0) {
      console.warn("the year validation rule, invalid \"".concat(value, "\" year value"));
      return errorMsg;
    } // Check the value boundaries


    if (startBoundary(value) === false || endBoundary(value) === false) {
      return errorMsg;
    }

    return true;
  };
}

/**
 * Validation result.
 */

/**
 * Validator
 *
 * Aggregated validation of given validation rules against the tested value.
 */
var Validator = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param rules Validation rules.
   * FIFO order, i.e. the rules will be tested from top to bottom.
   */
  function Validator(rules) {
    _classCallCheck(this, Validator);

    if (rules.length === 0) {
      throw new Error('the validator must have validation rules');
    }

    var _iterator = _createForOfIteratorHelper(rules),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var rule = _step.value;

        if (isFunction(rule) === false) {
          throw new Error("invalid validation rule, ".concat(rule));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    this._rules = rules;
  }
  /**
   * Get the validator rules.
   * @return
   */


  _createClass(Validator, [{
    key: "rules",
    get: function get() {
      return this._rules;
    }
    /**
     * Validate against the value.
     * If all rules are satisfied, the return value is true.
     * Otherwise the return value is an error message of the failed rule.
     * @param value Validated value.
     * @param firstErrorOnly Return only first error.
     * Defaults to true.
     * If set to false, it returns an array of errors, if any.
     * @return
     */

  }, {
    key: "validate",
    value: function validate(value) {
      var firstErrorOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var res = {
        valid: true,
        errors: []
      };

      var _iterator2 = _createForOfIteratorHelper(this._rules),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var rule = _step2.value;
          var result = rule(value);

          if (result !== true) {
            res.valid = false;
            res.errors.push(result);

            if (firstErrorOnly) {
              break;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return res;
    }
    /**
     * Validity predicate against the value.
     * @param value Validated value.
     * @return
     */

  }, {
    key: "valid",
    value: function valid(value) {
      var _iterator3 = _createForOfIteratorHelper(this._rules),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var rule = _step3.value;
          var result = rule(value);

          if (result !== true) {
            return false;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return true;
    }
    /**
     * Get all validation errors, if any.
     * Otherwise it returns empty array.
     * @param value Validated value.
     * @param firstErrorOnly Return only first error.
     * Defaults to false.
     * @return
     */

  }, {
    key: "errors",
    value: function errors(value) {
      var firstErrorOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var errors = [];

      var _iterator4 = _createForOfIteratorHelper(this._rules),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var rule = _step4.value;
          var result = rule(value);

          if (result !== true) {
            errors.push(result);

            if (firstErrorOnly) {
              break;
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return errors;
    }
  }]);

  return Validator;
}();

export { Validator, date, Validator as default, equal, exclude, include, length, pattern, present, range, year };
